import React,{useState} from 'react';
import { Link } from 'react-router-dom';
import {Form, Input, Button, Breadcrumb, BreadcrumbItem, Alert } from 'reactstrap'


const Post = (props) => {
    const [visible, setVisible] = useState(false);
    const onDismiss = () => setVisible(false);    
    
    return(
        <div>
            <br></br>
            
            <div className="containerForm">
                <h1 className="H1" align="left">Welcome</h1> 
                <p className="Font" align="left">Posted on <Link >Dec 17, 2020</Link></p>
        
                <p className="Font" align="left"> Welcome to the official website of ThothIT Consulting, 
                a Texas-based firm providing IT staffing, IT solutions and 
                consulting services all over the United States.</p>
                
                <br></br>
            </div>

            <div className="p-3">
                <Breadcrumb tag="nav" listTag="div">
                    <BreadcrumbItem tag="a" href="/">Home</BreadcrumbItem>
                    <BreadcrumbItem active tag="span">Posts</BreadcrumbItem>
                </Breadcrumb>
            </div>

            <div className="containerForm">
                <div className="wrapper" align="left">
                    <h5 align="left" className="H5"> Leave us Comment</h5>
                    <Form className="clearfix">
                        <Input className="form-control" type="text" placeholder="Your name" required/>
                        <br />
                        <Input className="form-control" type="text" placeholder="Email" required/>
                        <br />
                        <Input className="form-control" type="textarea" rows="3" placeholder="Your comment" required/>
                        <br />
                        <Alert color="success" isOpen={visible} toggle={onDismiss}>
                            Thank you for your comment!!
                        </Alert>
                        <Button color="primary" type="button" onClick={setVisible} className="btn btn-primary">Post Comment</Button>
                    </Form>
                </div>
            </div>
            <br></br>
        </div>
    )
}

export default Post;